export default "__VITE_ASSET__A_f4MQQJ__"